// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"b84f3887","455":"9bee4a85","496":"2b224f1b","568":"538d9650","581":"fed1e0c9"}[chunkId] + ".chunk.js";
};